import { Box, ButtonBase } from '@mui/material';
import React from 'react';
/**
 * Base layout wrapper for the content area inside a Card.
 * Dynamically renders either a clickable `ButtonBase` or a non-interactive `Box` container based on props.
 *
 * @template ContentBaseProps
 *
 * @param {ContentBaseProps} props - Props for configuring component.
 * @param {boolean} props.hasIcons - Whether the content includes icons (affects padding).
 * @param {boolean} props.hasBadge - Whether a badge is displayed (affects grid layout).
 * @param {() => void} [props.onClick] - Optional click handler; enables interactive rendering.
 * @param {string} [props.ariaLabel] - Optional ARIA label for accessibility support.
 * @param {React.ReactNode} props.children - Child components or elements to render inside.
 *
 * @returns {React.ReactElement} The rendered content container, either interactive or static.
 */
export const ContentBase = (props) => {
    const sx = {
        overflow: 'hidden',
        px: 2,
        py: props.hasIcons ? 1 : 0,
        display: 'grid',
        gap: 1,
        gridTemplateRows: !props.hasBadge ? 'auto' : 'auto 1fr auto',
        justifyContent: 'start',
    };
    return props.onClick ? (React.createElement(ButtonBase, { sx: sx, onClick: props.onClick, "aria-label": props.ariaLabel, focusRipple: true, "data-test": 'content' }, props.children)) : (React.createElement(Box, { sx: sx, "data-test": 'content' }, props.children));
};
